import { motion } from 'framer-motion';

export default function SettingsPage() {
  const apiUrl = process.env.REACT_APP_BACKEND_URL;

  return (
    <div className="space-y-6 max-w-2xl">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <h1 className="font-outfit text-2xl font-semibold text-white tracking-tight">Settings</h1>
      </motion.div>

      <div className="border border-[#1a1a1a] bg-[#0d0d0d] p-6 space-y-4">
        <div>
          <p className="text-[10px] font-mono text-[#555] tracking-[0.2em] uppercase mb-1">SYSTEM STATUS</p>
          <p className="text-xs font-mono text-green-400">Online</p>
        </div>
        <div>
          <p className="text-[10px] font-mono text-[#555] tracking-[0.2em] uppercase mb-1">API URL</p>
          <p className="text-xs font-mono text-[#888]">{apiUrl}</p>
        </div>
        <div>
          <p className="text-[10px] font-mono text-[#555] tracking-[0.2em] uppercase mb-1">AUTHENTICATION</p>
          <p className="text-xs font-mono text-yellow-400">TEMPORARY MOCK AUTH</p>
          <p className="text-[10px] font-mono text-[#444] mt-1">Replace with Supabase Auth in production</p>
        </div>
      </div>

      <div className="border border-[#1a1a1a] bg-[#0d0d0d] p-6">
        <p className="text-[10px] font-mono text-[#555] tracking-[0.2em] uppercase mb-3">FUTURE SETTINGS</p>
        <ul className="space-y-2 text-xs font-mono text-[#444]">
          <li>// Admin users management</li>
          <li>// Supabase Auth configuration</li>
          <li>// Email sender settings</li>
          <li>// Brand settings</li>
          <li>// Exhibition defaults</li>
        </ul>
      </div>
    </div>
  );
}
